import _ from 'lodash';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import { Select, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';
import { ISubcode } from '../../models/codes.model';

interface IYearSelect {
  year: string;
  setYear: (year: string) => void;
  hasAllOption: boolean
}

const YearSelect = ({ year, setYear, hasAllOption = true }: IYearSelect) => {
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  const { t } = useTranslation();

  // commonCodes 로딩 이후 컴포넌트가 생성 된다.
  if (!commonCodes || !(commonCodes.length > 0)) {
    return <Skeleton.Button active={true} size={'default'} shape={'default'} block={false} />;
  }

  // SY0005 = 연도
  const SY0005 = commonCodes.find(
    (item) => item.commonCode === 'SY0005',
  )?.detailCode;

  const all = { label: t('common.text.all'), value: 'all' };
  const _SY0005 = _.orderBy(SY0005, ['orderSeq'], ['desc']);

  return (
    <Select
      value={year}
      onChange={value => setYear(value)}
    >
      {
        hasAllOption && (
          <Select.Option value={all.value}>
            {all.label}
          </Select.Option>
        )
      }
      {
        _SY0005.map((item: ISubcode) => {
          return (
            <Select.Option
              key={item.detailCode}
              value={item.detailCode}
            >
              {item.korName}
            </Select.Option>
          )
        })
      }
    </Select>
  )
}

export default YearSelect;